/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of the pricing calculation for a ContractFunnel
 * @export
 */
export const ComparateurPricingStatus = {
    Pending: 'Pending',
    Loading: 'Loading',
    Success: 'Success',
    Error: 'Error',
    Timeout: 'Timeout'
} as const;
export type ComparateurPricingStatus = typeof ComparateurPricingStatus[keyof typeof ComparateurPricingStatus];


export function instanceOfComparateurPricingStatus(value: any): boolean {
    for (const key in ComparateurPricingStatus) {
        if (Object.prototype.hasOwnProperty.call(ComparateurPricingStatus, key)) {
            if (ComparateurPricingStatus[key as keyof typeof ComparateurPricingStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ComparateurPricingStatusFromJSON(json: any): ComparateurPricingStatus {
    return ComparateurPricingStatusFromJSONTyped(json, false);
}

export function ComparateurPricingStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComparateurPricingStatus {
    return json as ComparateurPricingStatus;
}

export function ComparateurPricingStatusToJSON(value?: ComparateurPricingStatus | null): any {
    return value as any;
}

export function ComparateurPricingStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ComparateurPricingStatus {
    return value as ComparateurPricingStatus;
}

